var map = {
	"./den.json": 1553,
	"./deu.json": 2903,
	"./eng.json": 8745,
	"./fin.json": 8756,
	"./fra.json": 9342,
	"./geo.json": 3987,
	"./heb.json": 3998,
	"./ita.json": 475,
	"./nld.json": 7441,
	"./nor.json": 1369,
	"./por.json": 1053,
	"./spa.json": 5248,
	"./swe.json": 3070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4891;